import React, { Component } from "react";
import styled from "styled-components";
import { FormattedMessage, injectIntl } from "react-intl";
import { connect } from "react-redux";
import PropTypes from "prop-types";

const mapStateToProps = state => {
    return {
        selectedLang: state.languageSession.selectedLang
    };
};
class LogoMark extends Component {
    static propTypes = {
        isLoginPage: PropTypes.bool,
        selectedLang: PropTypes.array
    };

    render() {
        const selectChinese = this.props.selectedLang.indexOf("zh") !== -1;
        return (
            <LogoMarkContainer
                showLogo={this.props.isLoginPage}
                className="LogoMarkContainer"
                selectChinese={selectChinese}
            >
                <div className="logo">
                    <FormattedMessage id="inputCredential.top.title" />
                </div>
            </LogoMarkContainer>
        );
    }
}

const LogoMarkContainer = styled.div`
    display: ${props => (props.showLogo ? "block" : "none")};
    .logo {
        font-size: 22px;
        font-weight: bold;
        margin-bottom: 35px;
    }
`;
export default connect(mapStateToProps)(injectIntl(LogoMark));
